import axios from 'axios';
import { getExpressAPIHost } from '../../utils';

const UploadMerchandisePurchases = async (year, month, formData) => {
    try {
        const response = await axios.post(`${getExpressAPIHost()}/merchandise-purchase/upload-merchandise-purchases/${year}/${month}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        throw new Error('Unable to upload file. Please contact support.');
    }
};
export default UploadMerchandisePurchases;
